import './track-importer-dropdown.sass';

import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import onClickOutside from 'react-onclickoutside';
import { Translate, I18n } from 'react-redux-i18n';
import uuidV4 from 'uuid/v4';

import FileInput from 'controls/file-input/FileInput';

import trigger from 'actions/trigger';

class TrackImporterDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShown: false
    };
  }

  handleClickOutside(event) {
    if ((event.target.nodeName !== 'svg')
      && !event.target.ownerSVGElement
      && (event.target.className.includes('track-importer-dropdown-toggle'))
      && !this.state.isShown
    ) {
      this.setState({ isShown: true });
      return;
    }

    this.setState({ isShown: false });
  }

  handleChange() {
    this.setState({ isShown: false });

    let guidInput = document.createElement('input');
    guidInput.name = 'trackGuid';
    guidInput.value = uuidV4().substring(0, 18).replace(/-/g, '');
    this.importTrackForm.appendChild(guidInput);

    let form = new FormData(this.importTrackForm);

    this.props.trigger('importItem', [form]);
  }

  render() {
    return (
      <ul className={ "track-importer-dropdown dropdown-menu " + ( this.state.isShown ? 'is-shown' : '' ) }>
        <li><a href="#"><b><Translate value='topMenu.trackImporterDropdown.fileImport'/></b></a></li>
        <li><a href="#">
          <form action="" ref={ (form) => { this.importTrackForm = form; }}>
            <FileInput
             className="btn btn-default"
             name="trackFileArchive"
             placeholder={ I18n.t('topMenu.trackImporterDropdown.chooseFile') }
             value={ this.state.file }
             onChange={ this.handleChange.bind(this) }
             />
          </form>
       </a></li>
      </ul>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    trigger: bindActionCreators(trigger, dispatch),
  }
}

export default connect(() => { return {} }, mapDispatchToProps)(onClickOutside(TrackImporterDropdown));
